import apiClient from '@/shared/api/client'
import type { Company } from '@/shared/types/master'

interface ListParams {
  page?: number
  page_size?: number
  search?: string
  is_active?: boolean
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const companiesApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<Company>> => {
    const res = await apiClient.get<PaginatedResponse<Company>>('/masters/companies', { params })
    return res.data
  },

  get: async (id: string): Promise<Company> => {
    const res = await apiClient.get<Company>(`/masters/companies/${id}`)
    return res.data
  },

  create: async (data: Omit<Company, 'id'>): Promise<Company> => {
    const res = await apiClient.post<Company>('/masters/companies', data)
    return res.data
  },

  update: async (id: string, data: Partial<Company>): Promise<Company> => {
    const res = await apiClient.patch<Company>(`/masters/companies/${id}`, data)
    return res.data
  },
}
